const Config = {
  contractName: "stacalc",
  contractAddress: "ST5K05SFTN5MZ17HTMA9HXSMHF6H301SYQNBD9E9",
};

export default Config;
